export default __webpack_public_path__ + "static/open-ai-56a2bf13458ed0521040410b06aadf1d.png";